export function getSearchParams() {
    let url = window.location.toString();
    let params = url?.split('?')[1]?.split('&');

    if (params !== undefined) {
        let obj = {};
        params.forEach((el) => {
            let [k, v] = el?.split('=') ?? [];
            if (k && v) {
                obj[k] = v.replaceAll('%20', ' ').split(',');
            }
        });

        return obj;
    }
}
